import { render, staticRenderFns } from "./areaInfo.vue?vue&type=template&id=3a8ed359&scoped=true"
import script from "./areaInfo.vue?vue&type=script&lang=js"
export * from "./areaInfo.vue?vue&type=script&lang=js"
import style0 from "./areaInfo.vue?vue&type=style&index=0&id=3a8ed359&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8ed359",
  null
  
)

export default component.exports